"use strict";
/**
 * CONNOX GMBH CONFIDENTIAL
 * ________________________
 *
 * Copyright (c) 2005 - 2020 Connox GmbH, All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property
 * of Connox GmbH and its suppliers, if any. The intellectual and
 * technical concepts contained herein are proprietary to Connox GmbH and
 * its suppliers and may be covered by German Laws and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is
 * strictly forbidden unless prior written permission is obtained from
 * Connox GmbH.
 */
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckoutRequestHandler = void 0;
const BaseRequestHandler_1 = require("../../requestHandler/BaseRequestHandler");
const getRequestConfigWithToken_1 = require("../../requestHandler/getRequestConfigWithToken");
const timer_1 = __importDefault(require("../../logger/timer"));
class CheckoutRequestHandler {
    static amazonPayPreAuthorize(paymentTransactionId, successUrl, failureUrl) {
        return __awaiter(this, void 0, void 0, function* () {
            const configuration = yield getRequestConfigWithToken_1.getRequestConfigurationWithToken();
            configuration.data = { successUrl, failureUrl: failureUrl || "" };
            return BaseRequestHandler_1.BaseRequestHandler.performRequest("POST", `/payments/amazon-pay/preauthorize/${paymentTransactionId}`, configuration);
        });
    }
    static authorizePayment(paymentTransactionId, braintreeNonce) {
        return __awaiter(this, void 0, void 0, function* () {
            const configuration = yield getRequestConfigWithToken_1.getRequestConfigurationWithToken();
            if (braintreeNonce !== undefined) {
                configuration.data = { braintreeNonce };
            }
            return BaseRequestHandler_1.BaseRequestHandler.performRequest("POST", `/payments/${paymentTransactionId}/authorize`, configuration);
        });
    }
    static countriesLookup(shopId) {
        return __awaiter(this, void 0, void 0, function* () {
            const configuration = yield getRequestConfigWithToken_1.getRequestConfigurationWithToken();
            return BaseRequestHandler_1.BaseRequestHandler.performRequest("GET", `/shop/${shopId}/lookup/countries`, configuration);
        });
    }
    static createCheckout(shopId, cartId) {
        return __awaiter(this, void 0, void 0, function* () {
            const configuration = yield getRequestConfigWithToken_1.getRequestConfigurationWithToken();
            configuration.data = { cartId };
            return BaseRequestHandler_1.BaseRequestHandler.performRequest("POST", `/shop/${shopId}/checkout`, configuration);
        });
    }
    static get(shopId, checkoutId) {
        return __awaiter(this, void 0, void 0, function* () {
            const configuration = yield getRequestConfigWithToken_1.getRequestConfigurationWithToken();
            return BaseRequestHandler_1.BaseRequestHandler.performRequest("GET", `/shop/${shopId}/checkout/${checkoutId}`, configuration);
        });
    }
    static getAmazonPayAddress(orderReferenceId) {
        return __awaiter(this, void 0, void 0, function* () {
            const configuration = yield getRequestConfigWithToken_1.getRequestConfigurationWithToken();
            return BaseRequestHandler_1.BaseRequestHandler.performRequest("GET", `/payments/amazon-pay/address/${orderReferenceId}`, configuration);
        });
    }
    static getBraintreeToken(currencyCode) {
        return __awaiter(this, void 0, void 0, function* () {
            const configuration = yield getRequestConfigWithToken_1.getRequestConfigurationWithToken();
            return BaseRequestHandler_1.BaseRequestHandler.performRequest("GET", `/payments/braintreeToken/${currencyCode}`, configuration);
        });
    }
    /**
     * Get all payment methods
     * @method GET
     * @param shopId
     * @param checkoutId
     */
    static getPayments(shopId, checkoutId) {
        return __awaiter(this, void 0, void 0, function* () {
            const configuration = yield getRequestConfigWithToken_1.getRequestConfigurationWithToken();
            return BaseRequestHandler_1.BaseRequestHandler.performRequest("GET", `/shop/${shopId}/checkout/${checkoutId}/payment`, configuration);
        });
    }
    /**
     * Gets all available shipping options for this checkout
     * @param {number} shopId
     * @param {string} checkoutId
     * @returns {Promise<IGetCheckoutShippingOptionsData[]>}
     */
    static getShippingOptions(shopId, checkoutId) {
        return __awaiter(this, void 0, void 0, function* () {
            const configuration = yield getRequestConfigWithToken_1.getRequestConfigurationWithToken();
            return BaseRequestHandler_1.BaseRequestHandler.performRequest("GET", `/shop/${shopId}/checkout/${checkoutId}/shipping`, configuration);
        });
    }
    static initializePayment(shopId, checkoutId, amazonPayOrderReferenceId) {
        return __awaiter(this, void 0, void 0, function* () {
            const configuration = yield getRequestConfigWithToken_1.getRequestConfigurationWithToken();
            configuration.data = {
                amazonPayOrderReferenceId,
                checkoutId,
                shopId,
            };
            return BaseRequestHandler_1.BaseRequestHandler.performRequest("POST", `/payments`, configuration);
        });
    }
    /**
     *
     * @param {number} shopId
     * @param {string} checkoutId
     * @param {ICheckoutPutParams} payload
     * @returns {Promise<ICheckoutData>}
     */
    static putParams(shopId, checkoutId, payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const configuration = yield getRequestConfigWithToken_1.getRequestConfigurationWithToken();
            configuration.data = payload;
            return BaseRequestHandler_1.BaseRequestHandler.performRequest("PUT", `/shop/${shopId}/checkout/${checkoutId}`, configuration);
        });
    }
    static stateLookup(shopId, countryCode) {
        return __awaiter(this, void 0, void 0, function* () {
            const configuration = yield getRequestConfigWithToken_1.getRequestConfigurationWithToken();
            return BaseRequestHandler_1.BaseRequestHandler.performRequest("GET", `/shop/${shopId}/lookup/countries/${countryCode}/states`, configuration);
        });
    }
}
__decorate([
    timer_1.default("API", "Checkout")
], CheckoutRequestHandler, "amazonPayPreAuthorize", null);
__decorate([
    timer_1.default("API", "Checkout")
], CheckoutRequestHandler, "countriesLookup", null);
__decorate([
    timer_1.default("API", "Checkout")
], CheckoutRequestHandler, "createCheckout", null);
__decorate([
    timer_1.default("API", "Checkout")
], CheckoutRequestHandler, "get", null);
__decorate([
    timer_1.default("API", "Checkout")
], CheckoutRequestHandler, "getAmazonPayAddress", null);
__decorate([
    timer_1.default("API", "Checkout")
], CheckoutRequestHandler, "getBraintreeToken", null);
__decorate([
    timer_1.default("API", "Checkout")
], CheckoutRequestHandler, "getPayments", null);
__decorate([
    timer_1.default("API", "Checkout")
], CheckoutRequestHandler, "getShippingOptions", null);
__decorate([
    timer_1.default("API", "Checkout")
], CheckoutRequestHandler, "initializePayment", null);
__decorate([
    timer_1.default("API", "Checkout")
], CheckoutRequestHandler, "putParams", null);
__decorate([
    timer_1.default("API", "Checkout")
], CheckoutRequestHandler, "stateLookup", null);
exports.CheckoutRequestHandler = CheckoutRequestHandler;
